import Alpine from 'alpinejs';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

Alpine.data('footerlarge', () => ({
    media: null,

    init() {
        const root = this.$root;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            root.classList.add('website-evolution--reduced-motion');
            return;
        }

        const line1 = root.querySelector('.cta-title-line-1 > div');
        const line2 = root.querySelector('.cta-title-line-2 > div');
        const button = root.querySelector('.button-cta');
        const trigger = line1 || line2;

        if (!line1 && !line2 && !button) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        this.media = gsap.matchMedia();
        this.media.add('(min-width: 1px)', () => {
            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger,
                    start: 'top 98%',
                    once: true,
                },
            });

            if (line1) {
                timeline.fromTo(
                    line1,
                    {yPercent: 100},
                    {yPercent: 0, duration: 0.8, ease: 'power3.out'},
                    0
                );
            }

            if (line2) {
                timeline.fromTo(
                    line2,
                    {yPercent: -100, x: -40},
                    {yPercent: 0, x: 0, duration: 0.8, ease: 'power3.out'},
                    0
                );
            }

            if (button) {
                timeline.fromTo(
                    button,
                    {x: -100, opacity: 0},
                    {x: 0, opacity: 1, duration: 0.5, delay: 0.3, ease: 'power1.out'},
                    0
                );
            }

            return () => {
                timeline.kill();
                gsap.set([line1, line2, button].filter(Boolean), {clearProps: 'transform,opacity'});
            };
        });

        requestAnimationFrame(() => ScrollTrigger.refresh());
    },

    destroy() {
        this.media?.revert();
    },
}));
